module.exports = __webpack_public_path__ + "img/2.29855c70.jpg";